export default __webpack_public_path__ + "static/media/img15.94556b98.PNG";